import styled from '@emotion/styled'

import { BaseButtonStyles } from 'components/ui/Buttons/Button/styles'
import theme from 'styles/theme'

export const RentButton = styled.button<{ isRentingInProgress: boolean }>`
  ${BaseButtonStyles};
  background: ${({ isRentingInProgress }) =>
    isRentingInProgress ? theme.token.var('colors.green.a125') : theme.token.var('colors.green.a200')};
  color: ${({ isRentingInProgress }) =>
    isRentingInProgress ? theme.token.var('colors.green.a200') : theme.token.var('colors.white')};
`
